import { api } from './BaseApi'
import {
  IMismatchTypeBase,
  IMismatchTypeDto,
  IMismatchTypeRequest,
  IMismatchTypeResponse,
  ISendMismatchTypeToFotoboxesRequest,
} from './dto/TypeMismatchDto'

export const typeMismatchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMismatchTypeList: builder.query<
      IMismatchTypeResponse,
      IMismatchTypeRequest
    >({
      query: (params) => ({
        url: '/non_compliant_type/',
        params: !!params ? params : {},
      }),
      providesTags: ['MismatchType'],
    }),
    getMismatchTypeDetail: builder.query<IMismatchTypeDto, { id: number }>({
      query: ({ id }) => ({
        url: `/non_compliant_type/${id}/`,
      }),
      providesTags: ['MismatchType'],
    }),
    createMismatchType: builder.mutation<IMismatchTypeDto, IMismatchTypeBase>({
      query: (body) => ({
        method: 'POST',
        url: '/non_compliant_type/',
        body,
      }),
      invalidatesTags: ['MismatchType'],
    }),
    updateMismatchType: builder.mutation<
      IMismatchTypeDto,
      { id: number; data: IMismatchTypeBase }
    >({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/non_compliant_type/${id}/`,
        body: data,
      }),
      invalidatesTags: ['MismatchType'],
    }),
    archiveMultipleMismatchType: builder.mutation<
      IMismatchTypeDto,
      { non_compliant_types: number[] }
    >({
      query: ({ non_compliant_types }) => ({
        method: 'PATCH',
        url: `/non_compliant_type/archive_multiple_non_compliant_types/`,
        body: { non_compliant_types },
      }),
      invalidatesTags: ['MismatchType'],
    }),
  }),
})

export const {
  useGetMismatchTypeListQuery,
  useGetMismatchTypeDetailQuery,
  useCreateMismatchTypeMutation,
  useUpdateMismatchTypeMutation,
  useArchiveMultipleMismatchTypeMutation,
} = typeMismatchApi
